<div class="date-selector-modal__container">
  <div class="date-selector-modal__info-header-container">
    <p [afTranslate]="'finish-block-modal.schedule-info-title'">Plazos de revisión recomendados:</p>
    @if (!configuration.isClientRecurrent) {
      <p [afTranslate]="'finish-block-modal.schedule-info-line-1'">1 año, si el riesgo es Alto o Muy Alto</p>
    }
    <p [afTranslate]="'finish-block-modal.schedule-info-line-2'">3 años, si el riesgo es Medio</p>
    <p [afTranslate]="'finish-block-modal.schedule-info-line-3'">7 años, si el riesgo es Bajo</p>
  </div>
  <!-- Calendar -->
  <div class="date-selector-modal__calendar-container">
    <p-calendar #calendarDate
      class="common-date__calendar"
      [(ngModel)]="dateSelector.preSelectItem"
      [inline]="true"
      [dateFormat]="'dd/mm/yy'"
      [hourFormat]="'24'"
      [firstDayOfWeek]="1"
      [minDate]="dateSelector.minDate"
      (onSelect)="changeDatePicker($event)">
      <ng-template pTemplate="previousicon">
        <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
      </ng-template>
      <ng-template pTemplate="nexticon">
        <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
      </ng-template>
    </p-calendar>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      [disabled]="!dateSelector.preSelectItem"
      (click)="handleAccept()">
      <span class="common-button__text-title"
        [afTranslate]="'common.apply'">_Aplicar</span>
    </button>
  </div>
</div>
